import openSocket from "socket.io-client";
import { getBackendUrl } from "../config";

/*
 * Le o token do localStorage na hora, e nao uma vez so.
 *
 * O token de acesso vale 15 minutos e e renovado durante a sessao. Se o
 * valor for capturado no momento de abrir o socket, toda RECONEXAO
 * automatica reenvia aquele mesmo token — que ja venceu. O servidor
 * recusa o handshake, o cliente tenta de novo com o mesmo token vencido,
 * e o ciclo nao sai do lugar ate alguem recarregar a pagina.
 *
 * O sintoma sao dois: enxurrada de "Socket auth failed" no log do
 * backend e uma fila de 400 (Bad Request) no console do navegador,
 * porque o cliente continua fazendo polling num sid que o servidor ja
 * derrubou. E o tempo real simplesmente para, sem erro na tela.
 */
function lerToken() {
  try {
    const stored = localStorage.getItem("token");
    return stored ? JSON.parse(stored) : null;
  } catch (err) {
    return null;
  }
}

function connectToSocket() {
    const backendUrl = getBackendUrl() || "http://localhost:8085";

    /*
     * O token vai em `auth`, e nao na query string: o handshake por
     * query grava o JWT completo em texto puro no access log do nginx
     * e em qualquer proxy do caminho.
     *
     * Em forma de FUNCAO, e nao de objeto: o socket.io-client chama esta
     * funcao a cada abertura de transporte, entao a reconexao pega o
     * token renovado em vez de repetir o vencido.
     */
    return openSocket(backendUrl, {
      /*
       * Ordem de transporte: polling primeiro, WebSocket depois.
       * =============================================================
       * Com "websocket" na frente, o socket abre direto em wss — e onde
       * o upgrade e recusado no caminho (proxy institucional, WAF,
       * balanceador que nao repassa os cabecalhos Upgrade/Connection) a
       * conexao nunca se estabelece. O sintoma nao parece de rede: a
       * tela carrega, as chamadas REST respondem, e so o tempo real
       * some — ticket que nao sai de "aguardando", conversa que nao
       * libera para digitar, tela que so muda com F5.
       *
       * Nesta ordem o socket conecta por HTTP long-polling, que passa
       * por qualquer proxy que ja entregue o resto da API, e o
       * engine.io tenta o upgrade para WebSocket em seguida. Onde o
       * upgrade funciona o ganho e o mesmo de antes; onde nao funciona,
       * o sistema continua atualizando sozinho em vez de parar.
       * =============================================================
       */
      transports: ["polling", "websocket"],
      auth: cb => cb({ token: lerToken() }),
    });
}

export default connectToSocket;
